export default __webpack_public_path__ + "static/media/phoneme.03457013.png";